import React from 'react';
import { Facebook } from 'lucide-react';
import ContentLayout, { H2, Prose } from '../components/ContentLayout';
import SmartImage from '../components/SmartImage';
import HERO from '../assets/mahima/mahima-hero.jpg';
import IMG_ARUN from '../assets/mahima/mahima-arun.jpg';
import IMG_TEMPLE from '../assets/mahima/mahima-temple.jpg';
import IMG_EXTRA from '../assets/mahima/mahima-extra.jpg';

const FB_URL = 'https://www.facebook.com/profile.php?id=61583757579796';

const MahimaTrivedi = () => (
  <ContentLayout
    testid="page-co-founder-mahima"
    eyebrow="Our Co-Founder"
    titleTop="Mahima"
    titleItalic="Trivedi"
    intro="A fellow traveler on the path inward — sharing the silence, the healing, and the moments of truth that meditation has gifted her."
  >
    <div className="grid md:grid-cols-[1.4fr_1fr] gap-10 items-start">
      <div>
        <H2 top="A note from" italic="Mahima" />
        <div className="mb-6 rounded-2xl border border-rose/50 bg-rose-soft/40 p-5" data-testid="krishna-priya-note">
          <p className="text-burgundy/90 leading-relaxed italic">
            Soulful Ma Krishna Priya has been an inspiration to expand our work in the Indian
            subcontinent and bring new energy to the organization. With her deep commitment to
            support the cause and her love for Osho, she is a strong pillar of the organization.
          </p>
        </div>
        <Prose>
          <p>With a full heart, I’m beginning a new journey… and I truly wish you to be a part of it.</p>
          <p>This page is not just about meditation techniques, it’s a space where I’ll be sharing my inner journey — the ups, the silence, the healing, the moments of truth… everything that meditation has gifted me.</p>
          <p>Through Osho’s meditations, I found a deeper connection with myself, a peace that words can’t fully express… and now, I want to share that experience with you.</p>
          <p>If somewhere within you there is a longing to slow down, to understand yourself, to feel a little more alive and peaceful… then this space is for you.</p>
          <p>Join me… not just as a follower, but as a fellow traveler on this beautiful path inward.</p>
        </Prose>

        <a
          href={FB_URL}
          target="_blank"
          rel="noreferrer"
          data-testid="mahima-facebook-link"
          className="inline-flex items-center gap-2 mt-6 rounded-full bg-[#1877F2] text-white px-5 py-2.5 text-sm font-medium hover:opacity-90 transition-opacity"
        >
          <Facebook className="w-4 h-4" /> Follow Mahima on Facebook
        </a>
      </div>

      <div className="grid gap-4">
        <SmartImage src={HERO} alt="Mahima Trivedi" className="rounded-3xl aspect-[3/4]" />
        <SmartImage src={IMG_ARUN} alt="Mahima Trivedi with Bodhisattva Swami Anand Arun" className="rounded-3xl aspect-[4/3]" />
      </div>
    </div>

    <div className="mt-12">
      <H2 top="Moments on the" italic="path" />
      <div className="grid sm:grid-cols-2 gap-4 mt-4">
        <SmartImage src={IMG_TEMPLE} alt="Mahima Trivedi at the temple" className="rounded-3xl aspect-[4/3]" />
        <SmartImage src={IMG_EXTRA} alt="Mahima Trivedi" className="rounded-3xl aspect-[4/3]" />
      </div>
    </div>
  </ContentLayout>
);

export default MahimaTrivedi;
